export class getServicesByIdRequest {
    public key: string = "getServicesById";
    constructor(
        public payload: string[] = [],
    ) { }
}